import { actionKeyGenerate, ACTION, GenericObject } from "../../../util/utils";

export const MODULE_KEY = "SPECIAL_ORDER_QUEUE";

export const KEYS: GenericObject = actionKeyGenerate(MODULE_KEY);

export const SPECIAL_ORDER_QUEUE_FETCH = KEYS[MODULE_KEY + ACTION.FETCH]


export const fetchSpecialOrders = (payload: any) => ({
  type: SPECIAL_ORDER_QUEUE_FETCH,
  payload,
});

export const fetchSpecialOrdersSuccess = (payload : any) => ({
  type: KEYS[MODULE_KEY + ACTION.SUCCESS],
  payload,
});

export const fetchSpecialOrdersFail = (error: any) => ({
  type: KEYS[MODULE_KEY + ACTION.FAIL],
  error,
});

// New: vendor receipt action types and creators (Mark As Received)
export const SPECIAL_ORDER_VENDOR_RECEIPT_FETCH = `${MODULE_KEY}_VENDOR_RECEIPT_FETCH`;
export const SPECIAL_ORDER_VENDOR_RECEIPT_SUCCESS = `${MODULE_KEY}_VENDOR_RECEIPT_SUCCESS`;
export const SPECIAL_ORDER_VENDOR_RECEIPT_FAIL = `${MODULE_KEY}_VENDOR_RECEIPT_FAIL`;

export const fetchVendorReceipt = (payload: any) => ({
  type: SPECIAL_ORDER_VENDOR_RECEIPT_FETCH,
  payload,
});

export const fetchVendorReceiptSuccess = (payload: any) => ({
  type: SPECIAL_ORDER_VENDOR_RECEIPT_SUCCESS,
  payload,
});

export const fetchVendorReceiptFail = (error: any) => ({
  type: SPECIAL_ORDER_VENDOR_RECEIPT_FAIL,
  error,
});


